import checkStoreServeTypeConfig from './checkServeType';

const ServeTypeUtils = {checkStoreServeTypeConfig};

export default ServeTypeUtils;